"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _get(target, property, receiver) { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(receiver); } return desc.value; }; } return _get(target, property, receiver || target); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

(function (window) {
  var SiteFooter = /*#__PURE__*/function (_window$AbstractView) {
    _inherits(SiteFooter, _window$AbstractView);

    var _super = _createSuper(SiteFooter);

    function SiteFooter() {
      var _this;

      _classCallCheck(this, SiteFooter);

      _this = _super.call(this, "site-footer-permanent", {
        $domElement: $("#site-footer-permanent"),
        watchResize: true
      });
      _this.$informationPanel = _this.$domElement.find("#site-footer__information-tabpanel");
      _this.$aboutusPanel = _this.$domElement.find("#site-footer__aboutus-tabpanel");
      _this.$informationBtn = _this.$domElement.find("#site-footer__information-btn");
      _this.$aboutusBtn = _this.$domElement.find("#site-footer__aboutus-btn");
      _this.accordionToggleBtns = _this.$domElement.find("a[data-toggle=\"collapse\"]");
      _this.$container_1 = _this.$domElement.find("#site-footer__container-0");
      _this.$container_2 = _this.$domElement.find("#site-footer__container-2");
      _this.$container_3 = _this.$domElement.find("#site-footer__container-3");
      _this.$container_4 = _this.$domElement.find("#site-footer__container-4");
      _this.$storesCarousel = _this.$container_2.find(".carousel").flickity({
        draggable: '>1',
        prevNextButtons: false,
        cellAlign: "left",
        groupCells: true,
        watchCSS: true
      });

      _this.$domElement.find('#site-footer__information-tabpanel a').on('click', function (event) {
        var $this = $(this);
        var current_url_relative = window.location.href.replace(window.location.origin, '').split('#')[0];
        var href_url_relative = $(this).attr('href').replace(window.location.origin, '').split('#')[0];
        var is_same_page = current_url_relative === href_url_relative;

        if (is_same_page) {
          event.preventDefault();
          event.stopPropagation();
          var HREF = $this.attr('href');
          HREF = HREF.substr(HREF.indexOf("#") + 1);
          window.location.hash = HREF; // return;
        }
      });

      return _this;
    }

    _createClass(SiteFooter, [{
      key: "init",
      value: function init() {
        _get(_getPrototypeOf(SiteFooter.prototype), "addModules", this).call(this, [new window.NewsletterForm(this.id + "_newsletter", {
          $domElement: this.$domElement.find(".newsletter-form")
        })]);

        this.$domElement.find(".it-lang-btn", ".en-lang-btn", ".es-lang-btn").on("click", this.changeLanguageCallback);
        this.accordionToggleBtns.on("click", function (event) {
          if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.LG)) {
            event.preventDefault();
          }
        });

        _get(_getPrototypeOf(SiteFooter.prototype), "init", this).call(this);
      }
    }, {
      key: "resizeHandler",
      value: function resizeHandler() {
        var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

        if (window.Breakpoints.matches(window.Breakpoints.MIN_WIDTH, window.Breakpoints.LG)) {
          this.$informationPanel.addClass("show");
          this.$aboutusPanel.addClass("show");
          this.$informationBtn.removeClass("collapsed");
          this.$aboutusPanel.removeClass("collapsed");
        } else {
          this.$informationPanel.removeClass("show");
          this.$aboutusPanel.removeClass("show");
          this.$informationBtn.addClass("collapsed");
          this.$aboutusPanel.addClass("collapsed");
        }

        this.$informationPanel.addClass("collapse");
        this.$aboutusPanel.addClass("collapse");
      }
    }, {
      key: "dispose",
      value: function dispose() {
        this.$storesCarousel.flickity('destroy');
        this.$storesCarousel = null;
        this.accordionToggleBtns.off("click");
        this.$informationPanel = null;
        this.$aboutusPanel = null;
        this.$informationBtn = null;
        this.$aboutusBtn = null;
        this.accordionToggleBtns = null;

        _get(_getPrototypeOf(SiteFooter.prototype), "dispose", this).call(this);
      }
    }]);

    return SiteFooter;
  }(window.AbstractView);

  window.SiteFooter = SiteFooter;
})(window);
